<template>
  <div class="main">
    <card class="help-center" v-if="category.title">
      <div class="help-center__title">Edit question category</div>
      <div
        class="input-wrapper"
        v-for="domain in domains"
        :key="domain.language"
      >
      <div class="input__title">
          {{ `Title ${domain.language.toUpperCase()}` }} 
          <span v-if="domain.language === 'en'"> (required field)</span>
        </div>
          <base-input
            class="input"
            v-model="category.title[domain.language]"
          ></base-input>
      </div>
    </card>
    <div class="help-center__button-wrapper">
      <button class="btn btn-primary" @click="update">Edit</button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";

export default {
  data: () => ({}),
  computed: {
    ...mapState("cmsApiCatalogs", ["domains"]),
    ...mapState("helpCenterCategories", ["category"]),
    getId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions("cmsApiCatalogs", ["getDomains"]),
    ...mapActions("helpCenterCategories", ["updateCategory", "getCategory"]),
    async getCategoryEvent() {
      await this.getDomains();
      await this.getCategory(this.$route.params.id);
    },
    update() {
      if(!this.category.title.en){
      return this.$notify({ type: "warning", title: "EN field should not be empty" });
      }
      this.$store.dispatch("setLoader", true);
      this.updateCategory({
        id: this.category.id,
        data: { title: this.category.title, id: this.category.id }
      })
        .then(() => {
          this.$notify({
            type: "success",
            title: "Question category has been updated"
          });
        })
        .catch(err => {
          this.$notify({ type: "warning", title: "Error" });
        })
        .finally(() => {
          this.$store.dispatch("setLoader", false);
        });
    }
  },

  created() {
    this.getCategoryEvent();
  }
};
</script>
